import { IPodcastEpisode } from '@wix/podcasts-common/dist/podcast';
import React from 'react';
import EpisodesGridItem from './EpisodesGridItem';

import styles from './EpisodesGrid.scss';

interface IEpisodesGridProps {
  episodes: IPodcastEpisode[];
  podcastImage: string;
  searchMode: boolean;
  focusIndex?: number;
  isLoading: boolean;
}

function EpisodesGrid({
  episodes,
  podcastImage,
  searchMode,
  focusIndex,
  isLoading,
}: IEpisodesGridProps) {
  return (
    <ul className={styles.grid} role="region" aria-busy={isLoading}>
      {episodes.map((episode, index) => (
        <EpisodesGridItem
          key={episode.id}
          podcastImage={podcastImage}
          episode={episode}
          isLatest={index === 0 && !searchMode}
          shouldFocus={focusIndex === index}
        />
      ))}
    </ul>
  );
}

export default EpisodesGrid;
